import { render } from "./Recovery.vue?vue&type=template&id=9e3ded0c&scoped=true&ts=true"
import script from "./Recovery.vue?vue&type=script&lang=ts"
export * from "./Recovery.vue?vue&type=script&lang=ts"

import "./Recovery.vue?vue&type=style&index=0&id=9e3ded0c&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3ded0c"]])

export default __exports__